import React, { FC, useMemo } from 'react';

import {
	EVINCED_SEVERITIES,
	EvIssueTypesBySeverityBreakdownChart,
	PatternData
} from '@evinced-private/ui-common';

import {
	mobileSeverityPatterns,
	prepareDataForTotalIssuesBreakdownByIssueTypeChart
} from 'src/common/helpers/MobileChartsHelper';
import { MOBILE_SEVERITY_MAP } from 'src/common/helpers/MobileQueriesHelper';
import { MobileIssueTypeCount } from 'src/common/types/MobileSingleSessionTypes';

interface IMobileTotalIssuesBreakdownByIssueTypeChartProps {
	data: MobileIssueTypeCount[];
	onBarClick: (issueType: string, severity: EVINCED_SEVERITIES) => void;
}

export const MobileTotalIssuesBreakdownByIssueTypeChart: FC<
	IMobileTotalIssuesBreakdownByIssueTypeChartProps
> = ({ data, onBarClick }) => {
	const transformedData = useMemo(
		() => prepareDataForTotalIssuesBreakdownByIssueTypeChart(data),
		[data]
	);

	const patterns: PatternData[] = useMemo(() => {
		const allIssueTypes = transformedData.flatMap((severity) => severity.issueTypesCount);

		return allIssueTypes.map((issueType) => {
			const severityPattern = mobileSeverityPatterns.find(
				(pattern) => pattern.id === issueType.severityId
			);

			return {
				id: issueType.id,
				label: issueType.typeLabel,
				color: severityPattern?.color || ''
			};
		});
	}, [transformedData]);

	return (
		<EvIssueTypesBySeverityBreakdownChart
			enableFocusBorder={true}
			typesCountBySeverity={transformedData}
			patterns={patterns}
			onBarItemClick={({ type, severity }) => {
				const originalItem = data.find(
					(item) => item.type === type && MOBILE_SEVERITY_MAP[item.severity] === severity
				);
				if (originalItem) {
					onBarClick(type, originalItem.severity as EVINCED_SEVERITIES);
				}
			}}
		/>
	);
};
